module.exports = __webpack_public_path__ + "static/media/twitter.bf8e4810.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/twitter.png
// module id = 899
// module chunks = 0